import React from "react";
import { ImInfo } from "react-icons/im";
import HoverTooltip from "./Hovertootip";

interface InfoTooltipProps {
  content: string;
  className?: string;
  placement?: "left" | "right" | "top" | "bottom";
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({
  content,
  className,
  placement,
}) => {
  return (
    <HoverTooltip content={content}>
      <div className="cursor-pointer text-customGrayBase ml-2">
        <ImInfo size={14} />
      </div>
    </HoverTooltip>
  );
};

export default InfoTooltip;
